import React from 'react';

import { Flex } from 'antd';

import { CopyableText } from './CopyableText';

export const AccountEmailId = ({
  email,
  id,
}: {
  email: string;
  id: string;
}) => (
  <Flex vertical gap={6} align="flex-end">
    <CopyableText value={email} />
    <CopyableText value={id} />
  </Flex>
);
